import BaseIcon from './BaseIcon';
import { ReactElement, SVGProps } from 'react';

export default function MagnifyingGlassIcon(props: SVGProps<any>): ReactElement {
  return (
    <BaseIcon {...props}>
      <path
        d="m21.398 21.172-4.817-4.817a8.077 8.077 0 1 0-.795.795l4.817 4.817a.563.563 0 0 0 .795-.795M3.563 11.069a6.937 6.937 0 1 1 6.937 6.937 6.946 6.946 0 0 1-6.937-6.937"
        fill="currentColor"
      />
    </BaseIcon>
  );
}
